export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/legal_writing.64c960d.svg";